require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-bamboe-doodskist.json") })
        }
      }, "path---projecten-bamboe-doodskist");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-bamboe-doodskist!./.cache/json/projecten-bamboe-doodskist.json
// module id = 397
// module chunks = 231608221292675